<template>
  <div class="share">
    <img id="icon1" src="http://file.market.xiaomi.com/thumbnail/PNG/l114/AppStore/0459dc50310d148541581a490f12ea60221ca7736" />
    <h1 id="appName">清理助手</h1>
	<h1 id="versionName">{{versionName}}</h1>
    <h2 id="desc">AI清理更干净! 一款智能清理工具</h2>
	<button id="downBtn" v-if="isShowDowloadBtn" v-on:click="download">{{downloadBtn}}</button>
	<span v-if="!isShowDowloadBtn">
		<p id="tip">1，请点击右上角 “···”</p>
		<p id="tip">2，选择 “在浏览器中打开”</p>
	</span>
	
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
		downloadUrl:"",
        msg: 'Welcome to Your Vue.js App',
		downloadBtn:"下 载",
		versionName:"清理助手",
		isShowDowloadBtn:true,
		isIos:false
    }
  },
	methods:{
		download: function(){
			console.log(this.downloadUrl);
			if (!this.isIos){
				window.open(this.downloadUrl);
			}else{
				alert("清理助手暂不支持IOS系统");
			}
		},
		isWeixinBrowser: function() {
            return (/micromessenger/.test(ua)) ? true : false;
        }
	},
	created:function() {
		this.$http.get("https://www.ddidda.com/cleaner-app/upgrade/0/0")
		.then(function(response){
				this.downloadUrl = response.data.data.apk_url;
				this.versionName = response.data.data.version_name;
				 let ua = navigator.userAgent.toLowerCase();
				 console.log("ua: " + ua);
				 if (ua.indexOf("iphone") > 0){
					 this.downloadBtn = "不支持IOS系统";
					 this.isIos = true;
				 }else if (ua.indexOf("android") > 0){
					if (ua.match(/MicroMessenger/i) == "micromessenger") {
						this.downloadBtn = ""
						console.log("wechat");
						this.downloadBtn = "右上角···在浏览器中打开";
						this.isShowDowloadBtn = false;
					}else{
						window.open(this.downloadUrl);
					}
				}
		});
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	
body{
	text-align: center;
}

#appName{
	font-size: 20px;
	
}

#versionName{
	font-size: 10px;
}

#desc{
	font-size: 15px;
	margin-top: 10px;
	font-style: oblique;
	color: black;
}

#icon1{
	margin-top: 25%;
	height: 70px;
	width: 70px;
}

#downBtn{
	margin-top: 50px;
	width: 200px;
	height: 40px;
	text-decoration:none;  
    background:forestgreen;  
    color:#f2f2f2;  
      
    padding: 10px 30px 10px 30px;  
    font-size:12px;  
    font-family: 微软雅黑,宋体,Arial,Helvetica,Verdana,sans-serif;  
    font-weight:bold;  
    border-radius:3px;  
      
    -webkit-transition:all linear 0.30s;  
    -moz-transition:all linear 0.30s;  
    transition:all linear 0.30s;  
}

#tip{
	margin-top: 5px;
	color:red;  
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue